module.exports = function getResource(label, vars = []) {
    const resources = {
        unverifiedTitle: 'Veuillez revérifier votre adresse',
        unverifiedLegend: 'Votre adresse d’expédition n’a pas pu être vérifiée.',
        unverifiedButtonText: 'Modifier l’adresse',
        recommendedTitle: 'Adresse recommandée',
        recommendedButtonText: 'Utilisation recommandée',
        unverifiedTitleR3: 'Veuillez valider l’adresse',
        unverifiedLegendR3: 'Votre adresse n’a pas pu être validée.',
        unverifiedButtonTextR3: 'Modifier l’adresse'
    };

    return resources[label];
};
